import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section className="py-12 md:py-16">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            漫画分类
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            八大分类，涵盖少年漫画所有热门类型，一键找到你的最爱
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 mb-3 line-clamp-2">
                {cat.description}
              </p>
              <span className="text-xs text-primary-600 font-medium">
                {cat.count} 部作品
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}